import * as Yup from 'yup';

import { Skill } from 'interface/skill';

// Yup's nested shape types infer id/name as optional; runtime matches Skill.
const skillSchema = Yup.object({
  name: Yup.string()
    .matches(/^[a-zA-Z][\sa-z0-9A-Z\-/]{1,50}$/, 'Invalid Name')
    .required('Please enter the skill name'),
  description: Yup.string()
    .matches(/^[a-zA-Z][\sa-z0-9A-Z\-/]{1,200}$/, 'Invalid Description')
    .nullable(),
  skillCategory: Yup.object()
    .shape({
      id: Yup.number().required(),
      name: Yup.string().required(),
    })
    .required('Please enter skill category'),
}) as Yup.ObjectSchema<Skill>;

export default skillSchema;
